export const label = {
  total: "Loan Amount",
  repay: "Loan Balance",
  next: "Next Payment",
  due: "Payment Due on",
  creditLimit: "Credit Limit",
  repaid: "Repaid",
  availableCredit: "Available Credit",
  available: "Available",
  credit: "Credit",
  overTheLimit: "Over the Limit",
  over: "Over",
  the: "The",
  limit: "Limit"
};